import ninegrid from "../index.js";

export class ngColResizer
{
	#owner;
	#panel;
	#grip;
	#tooltip;
	#ready;
	#th1;
	#th2;
	#isRightContainer;
	#prevWidth = [];
	
	constructor (owner) {

		this.#owner	= owner;

		this.#panel = $('<div class="resizer-col-panel"><div class="grip"></div><div class="tooltip"><div></div><span></span><div></div></div></div>').hide();
		$(this.#owner.body).append(this.#panel);
		
		this.#grip	= this.#panel.find(".grip");
		this.#tooltip= this.#panel.find(".tooltip");

		this.resetEvent();
	}
	
	resetEvent = () => {
		$(".ng-table > thead", this.#owner.body)
			.off("mousemove", this.#thead_onMouseMove)
			//.off("touchstart", this.#thead_onTouchStart)
			.off("mousedown", this.#thead_onMouseDown)
			.off("dblclick", this.#thead_onDblClick);
		
		$(document)
			//.off("touchend",this.#document_onMouseUp)
			.off("mouseup", this.#document_onMouseUp);
		
		$(".ng-table > thead", this.#owner.body)
			.on("mousemove", this.#thead_onMouseMove)
			//.on("touchstart", this.#thead_onTouchStart)
			.on("mousedown", this.#thead_onMouseDown)
			.on("dblclick", this.#thead_onDblClick);
		
		$(document)
			//.on("touchend",this.#document_onMouseUp)
			.on("mouseup", this.#document_onMouseUp);
	}
	
	autoFit = v => {

		if (!this.#owner.body) return;

		if (v) {
			this.#owner.body.querySelector('ng-hscrollbar').scrollToHome();
			
			this.#prevWidth = [];
			var totalWidth = 0;
			
			$(".ng-container-body col", this.#owner.body).each((i,el) => { this.#prevWidth.push({ col: el, width: parseInt(el.getAttribute("width")), }); });
			this.#prevWidth.forEach(o => { totalWidth += o.width; });
	
			$('.ng-container-body > table', this.#owner.body).css({ "width": "100%", "min-width": "100%", });
			var tableWidth = $('.ng-container-body', this.#owner.body).width();
			
			if (tableWidth != 0) {
				this.#prevWidth.forEach(o => { var w = o.width * tableWidth / totalWidth; o.col.setAttribute("width", w); });
			}
		} else {
			$('.ng-container-body > table', this.#owner.body).css({ "width": "0", "min-width": "0", });
			this.#prevWidth.forEach(o => { o.col.setAttribute("width", o.width); });
		}
	};
	
	#thead_onDblClick = e => {
		if (e.target.style.cursor == "col-resize") this.#onDblClick(e);
	};
	
	#document_onMouseUp = e => {
		this.#ready = false;
	};
	
	#thead_onMouseMove = e => {
		
		if (e.target.closest("ng-info")) return;
		
		e.target = e.target.closest("th,td");

		if (!e.target) return;
		if (this.#owner.getAttribute("col-resizable") != "true") return;
		if (e.altKey || e.ctrlKey || e.shiftkey) return;

		e.preventDefault();
		
		if (e.offsetX <= 2 || e.offsetX >= e.target.offsetWidth - 2) {
				
			if (e.offsetX <= 2 && this.#owner.tableUtils.isFirst(e.target)) return;
			if (e.offsetX >= e.target.offsetWidth - 2 && this.#owner.tableUtils.isLast(e.target)) return;
			
			e.target.style.cursor = "col-resize";
		}
		else {
			e.target.style.cursor = "auto";
		}
	};
	
	#thead_onTouchStart = (e) => {

		this.#ready = true;
		setTimeout(() => {
			if (this.#ready) this.#onTouchStart(e);
		}, 500);
	};
	
	#thead_onMouseDown = (e) => {
		const cell = e.target.closest("th,td");

		if (!cell || cell.style.cursor != "col-resize") return;

		this.#ready = true;
		setTimeout(() => {
			if (this.#ready) this.#onMouseDown(e);
		}, 500);
	};
		
	#onTouchStart = (e) => {

		e.target = e.target.closest("th,td");
		
		var rect = e.target.getBoundingClientRect();
		e.offsetX = e.targetTouches[0].pageX - rect.left;
		e.pageX = e.changedTouches[0].pageX;
		e.buttons = 1;
		
		this.#onMouseDown(e);

		if (this.#panel.is(":visible")) {
			$(e.target).on("touchmove", e => this.#onTouchMove(e));
			$(e.target).on("touchend", e => this.#onTouchEnd(e));
		}
		else {
			$(e.target).off("touchmove", e => this.#onTouchMove(e));
			$(e.target).off("touchend", e => this.#onTouchEnd(e));
		}
	};
	
	#onMouseDown = (e) => {

		e.target = e.target.closest("th,td");
		
		if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftkey) return;

		this.#isRightContainer = e.target.closest(".ng-container-right") ? true : false;
		
		//if (e.offsetX <= 2) {
		if (e.pageX - $(e.target).offset().left <= 3) {
			var colIndicator = $(`.col-indicator[data-col=${e.target.dataset.col}]`, this.#owner.body).not(".dummy")[0];

			this.#th1 = this.#owner.tableUtils.prev(colIndicator);
			this.#th2 = $(colIndicator);
		} else {
			if ($(e.target).width() - e.offsetX > 2) return;
			
			var col = parseInt(e.target.dataset.col) + e.target.colSpan - 1;
			var colIndicator = $(`.col-indicator[data-col=${col}]`, this.#owner.body).not(".dummy")[0];

			this.#th1 = $(colIndicator);
			this.#th2 = this.#owner.tableUtils.next(colIndicator);
		}

		this.#panel.show();
		
		this.#grip.offset({top: $(".ng-container-body", this.#owner.body).offset().top, left: this.#th2.offset().left - 1});
		this.#grip.height(this.#owner.body.querySelector(".ng-container-body").offsetHeight);

		this.#tooltip.offset({ top: $(".ng-container-body", this.#owner.body).offset().top });
		
		this.#moveAt(e.pageX);
		
		$(this.#panel)
			.off("mousemove",	this.#onMouseMove)
			.off('mouseup',		this.#onMouseUp)
			.on("mousemove",	this.#onMouseMove)
			.on('mouseup',		this.#onMouseUp);
	};
	
	#onTouchMove = (e) => {
		this.#moveAt(e.changedTouches[0].pageX);
	};
	#onMouseMove = (e) => {
		this.#moveAt(e.pageX);
	};
	
	#onTouchEnd = e => {
		
		$(e.target).off("touchmove", e => this.#onTouchMove(e));
		$(e.target).off("touchend", e => this.#onTouchEnd(e));
		
		this.#onMouseUp(e);
	};
	
	
	#onMouseUp = e => {
			
		if (!this.#grip.is(":visible")) return;
		
		var colWidth;
		if (this.#isRightContainer) {
			colWidth = this.#th2.offset().left - this.#grip.offset().left + this.#th2.width();
		}
		else {
			colWidth = this.#grip.offset().left - this.#th1.offset().left + 1;
		}
	
		if (colWidth <= 1) colWidth = 0;
		
		const colIndex = this.#isRightContainer ? this.#th2[0].dataset.col : this.#th1[0].dataset.col;
		
		this.#owner.columns.width(colIndex, colWidth);
		
		
		$(this.#panel).off("mousemove", this.#onMouseMove);
		$(this.#panel).off("mouseup", this.#onMouseUp);
		//$(this.#panel).off("mouseout", this.#onMouseOut);
		
		this.#panel.hide();
		
		//this.#owner.refresh();
	}
	
	#moveAt = (pageX) => {
		/** grip */
		if (!this.#isRightContainer && pageX < this.#th1.offset().left) pageX = this.#th1.offset().left;
		this.#grip.offset({left:pageX});

		/** tooltip */
		var l = parseInt(this.#grip.offset().left);
		var w, w1, w2;

		if (this.#isRightContainer) {
			w1 = this.#th2.width() + this.#th2.offset().left - this.#grip.offset().left;
			w2 = w1 < 10 ? 10 : w1 - 1;
			
			w = parseInt(this.#th2.width() + this.#th2.offset().left - this.#grip.offset().left);
		}
		else {
			w1 = parseInt(l - this.#th1.offset().left);//this.#th1.width();
			w2 = w1;
			
			w = parseInt(l - this.#th1.offset().left + 1);

			l = l - w2;
		}

		if (w <= 1) w = 0;

		this.#tooltip.offset({left: l});
		this.#tooltip.width(w2);
		this.#tooltip.find("span").text(w);
	}
	
	#onDblClick = (e) => {
		var td = e.target.closest("th,td");
		
		var prev	= this.#owner.tableUtils.prev(td);
		var next	= this.#owner.tableUtils.next(td);
		var target	= this.#owner.getBand(td.dataset.col) == ninegrid.BAND.RIGHT ? ((e.offsetX <= 2) ? $(td) : next) : ((e.offsetX <= 2) ? prev : $(td));

		this.#owner.setColumnWidthFit(target[0].dataset.col);
	}
}